import { Inject, Injectable } from '@angular/core';
import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(@Inject(WA_LOCAL_STORAGE) readonly storage: Storage) {}
}
